import MuiCssBaseline from './MuiCssBaseline';
import MuiButton from './MuiButton';
import MuiTableCell from './MuiTableCell';
import MuiListItem from './MuiListItem';
import MuiListItemText from './MuiListItemText';
import MuiAppBar from './MuiAppBar';
import { MuiAccordion, MuiAccordionSummary } from './MuiAccordion';
import MuiCard from './MuiCard';
import MuiTabs from './MuiTabs';
import MuiSelect from './MuiSelect';
import MuiMenu from './MuiMenu';
import MuiMenuItem from './MuiMenuItem';
import MuiDivider from './MuiDivider';
import MuiTooltip from './MuiTooltip';
import MuiPopover from './MuiPopover';

const overrides = {
  MuiAppBar,
  MuiCard,
  MuiTabs,
  MuiAccordion,
  MuiAccordionSummary,
  MuiCssBaseline,
  MuiTooltip,
  MuiButton,
  MuiTableCell,
  MuiListItem,
  MuiListItemText,
  MuiDivider,
  MuiSelect,
  MuiMenu,
  MuiMenuItem,
  MuiPopover,
};

export default overrides;
